export default {
    parts: ['container', 'viewText', 'termsLink'],
    baseStyle: (props) => ({
        container: {
            '.chakra-checkbox__label': {
                ...(props?.theme?.textStyles?.bodyXsRegular || {})
            }
        },
        viewText: {
            textStyle: 'bodyXsRegular'
        },
        termsLink: {
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    })
}
